import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'pauseState';

export const getAllPauseVideos = createAsyncThunk(
    'pauseState/getAllPauseVideos',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/audiovideos?group=ALL&tag=PauseScreen`,
                withCredentials: true,
                auth: createAuth(getState)
            });
            return response.data;
        } catch (error) {
            console.log('ERROR FETCHING PAUSEVIDEOS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    currentVideoIndex: 0,
    staticPauseVideo: false,
    pauseVideos: [],
    status: 'idle',
    error: null,
};

const pauseSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        nextVideo: (state) => {
            if (state.currentVideoIndex >= state.pauseVideos.length) {
                state.currentVideoIndex = 0;
            } else {
                state.currentVideoIndex += 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllPauseVideos.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllPauseVideos.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.pauseVideos = action.payload;
            })
            .addCase(getAllPauseVideos.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export const { nextVideo } = pauseSlice.actions;

export default pauseSlice.reducer;